<tcc-mono-dialog-layout
  title="Filter instellen"
  [saveText]="'Opslaan'"
  [displayBottomButtons]="true"
  (onSave)="save()"
>
  <form [formGroup]="form">
    <ion-list formArrayName="items">
      <ion-item *ngFor="let item of items.controls; let i = index" [formGroupName]="i" lines="full" class="filter-color-item">
        <ion-label class="ion-text-wrap">
          <strong>{{ getColorName(i) }}</strong>
          <div class="date-range-fields">
            <ion-input
              type="date"
              formControlName="min_birth_date"
              label="Van"
              labelPlacement="stacked"
              [disabled]="!item.get('used')?.value"
            ></ion-input>
            <ion-input
              type="date"
              formControlName="max_birth_date"
              label="Tot"
              labelPlacement="stacked"
              [disabled]="!item.get('used')?.value"
            ></ion-input>
          </div>
          <ng-container *ngIf="ageRangeHints(item.get('min_birth_date')?.value, item.get('max_birth_date')?.value) as hints">
            <div class="age-hints" *ngIf="hints.length">
              <ion-note *ngFor="let hint of hints" class="age-hint">
                {{ hint }}
              </ion-note>
            </div>
          </ng-container>
        </ion-label>
        <ion-toggle formControlName="used" slot="end"></ion-toggle>
      </ion-item>
    </ion-list>
  </form>
  <ion-note *ngIf="saving" class="ion-padding">Opslaan...</ion-note>
</tcc-mono-dialog-layout>
